import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import parse from "html-react-parser";
import "./view-terms.css";
import { useLoanApplicationPreferences } from "hooks/useLoanApplicationPreferences";

export function ViewTermsButton() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [terms, setTerms] = useState<string>("");

    const { data: preferences } = useLoanApplicationPreferences();

    useEffect(() => {
        if (preferences?.pdf?.terms_of_service) {
            setTerms(preferences.pdf.terms_of_service);
        }
    }, [preferences]);

    if (!preferences?.pdf?.terms_of_service) {
        return null;
    }

    return (
        <>
            <Button size="sm" variant="link" onClick={onOpen}>
                Terms of Use
            </Button>
            <Modal isOpen={isOpen} onClose={onClose} size="6xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader textTransform="capitalize">
                        Terms of Use
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody className="view-terms">{parse(terms)}</ModalBody>
                    <ModalFooter>
                        <Button onClick={onClose}>Close</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}
